import Vue from "vue";

Vue.filter("formatEnum", function(value) {
  if (value) {
    return value.replace(/([A-Z])/g, " $1").trim();
  }
});
